import PropTypes from "prop-types"
import queryString from "query-string"
import React, { useCallback, useEffect, useRef, useState } from "react"

import api from "apis"
import { history } from "app-store-v2/index"

export default function fetchOrder(WrappedComponent) {
  const FetchOrder = ({
    location,
    orderUpdateData,
    rmaType,
    validatePath,
    ...props
  }) => {
    const [data, setData] = useState(orderUpdateData)
    const [loading, setLoading] = useState(true)
    const [orderNumber, setOrderNumber] = useState("")
    const [orderToken, setOrderToken] = useState("")
    const [customerGuid, setGuid] = useState("")
    const cancelled = useRef(false)

    const getOrder = useCallback(async () => {
      if (orderNumber && (customerGuid || orderToken)) {
        const response = await api
          .post(validatePath, {
            customer_guid: customerGuid,
            order_number: orderNumber,
            order_token: orderToken,
            rma_type: rmaType,
          })
          .catch((err) => console.log(err))

        if (!cancelled.current) {
          let responseData
          if (response && response.data) {
            responseData = response.data
          } else {
            responseData = response
          }

          if (responseData && responseData.redirect_url) {
            setLoading(false)
            return history.push(responseData.redirect_url)
          }

          if (
            responseData &&
            (responseData.order ||
              responseData.repair_items ||
              responseData.line_items)
          ) {
            setData(responseData)
          }
          setLoading(false)
        }
      }
    }, [customerGuid, orderNumber, orderToken, rmaType])

    useEffect(() => {
      const search = queryString.parse(location.search)
      const { order_number, customer_guid, order_token } = search

      if (!cancelled.current) {
        if (order_number) {
          setOrderNumber(order_number)
        } else {
          setLoading(false)
        }
        if (order_token) {
          setOrderToken(order_token)
        }
        if (customer_guid) {
          setGuid(customer_guid)
        }
      }
    }, [location, orderUpdateData])

    useEffect(() => {
      getOrder()
    }, [getOrder])

    useEffect(() => {
      return () => (cancelled.current = true)
    }, [])

    return (
      <WrappedComponent
        data={data}
        loading={loading}
        orderNumber={orderNumber}
        {...props}
      />
    )
  }

  FetchOrder.propTypes = {
    location: PropTypes.object,
    orderUpdateData: PropTypes.object,
    rmaType: PropTypes.string,
    validatePath: PropTypes.string,
  }
  return FetchOrder
}
